import React, {useState} from 'react';
import {Box, Stepper, Step, StepButton, Card} from '@mui/material';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import QuestionnairesPage from './QuestionnairesPage';
import QuestionsPage from './QuestionsPage';
import FeaturesPage from './FeaturesPage';
import AddOnsPage from './AddOnsPage';
import MappingsPage from './MappingsPage';

const steps = [
  {label: 'Questionnaires', description: 'Link questionnaires to pages'},
  {label: 'Features', description: 'Create feature categories and features'},
  {label: 'Questions', description: 'Create questions and answer options'},
  {label: 'Add-ons', description: 'Create add-ons with pricing'},
  {label: 'Mappings', description: 'Map answer combinations to plans'},
];

// All step components in order — index must match `steps` array above
// Features (step 2) must come before Questions (step 3) so features exist
// when users attach them to answer options.
const STEP_COMPONENTS = [
  QuestionnairesPage,
  FeaturesPage,
  QuestionsPage,
  AddOnsPage,
  MappingsPage,
];

function ServicePlanManager() {
  const [activeStep, setActiveStep] = useState(0);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Card sx={{mb: 3, p: 3}}>
          <MDBox mb={2}>
            <MDTypography variant="h4" mb={1}>
              Service Plan Configuration
            </MDTypography>
            <MDTypography variant="body2" color="text.secondary">
              Complete setup: Step {activeStep + 1} of {steps.length}
            </MDTypography>
          </MDBox>

          <Stepper nonLinear activeStep={activeStep}>
            {steps.map((step, index) => (
              <Step key={step.label}>
                <StepButton
                  color="inherit"
                  onClick={() => setActiveStep(index)}
                  sx={{
                    '& .MuiStepLabel-label': {
                      fontSize: '0.875rem',
                      fontWeight: activeStep === index ? 'bold' : 'normal',
                    },
                  }}>
                  <Box>
                    <MDTypography
                      variant="button"
                      fontWeight={activeStep === index ? 'bold' : 'regular'}>
                      {step.label}
                    </MDTypography>
                    <MDTypography
                      variant="caption"
                      color="text.secondary"
                      display="block">
                      {step.description}
                    </MDTypography>
                  </Box>
                </StepButton>
              </Step>
            ))}
          </Stepper>
        </Card>

        {/*
          Render ALL step components at once but only show the active one.
          This prevents unmount/remount on tab switch, which was causing
          each component to re-fetch its data on every step change.
        */}
        <Box mt={3}>
          {STEP_COMPONENTS.map((StepComponent, index) => (
            <Box key={index} display={activeStep === index ? 'block' : 'none'}>
              <StepComponent />
            </Box>
          ))}
        </Box>
      </MDBox>
    </DashboardLayout>
  );
}

export default ServicePlanManager;
